(() => {
  // Only rescue a broken/missing case-type control; leave working theme pickers alone.
  function init() {
    const config = document.querySelector('[data-vv-variant-backup]');
    if (!config || document.querySelector('[data-vv-fallback-fieldset]')) return;
    let variants;
    try { variants = JSON.parse(config.textContent || '[]'); } catch { return; }
    const choices = variants
      .map(v => ({ id: v.id, name: v.option1 || v.title, available: Boolean(v.available), price: v.price }))
      .filter(v => v.id && ['Standart','MagSafe'].includes(v.name));
    if (choices.length < 2) return;
    const inView = node => !!(node && node.getClientRects().length &&
      getComputedStyle(node).display !== 'none' && getComputedStyle(node).visibility !== 'hidden');
    const original = [
      ...document.querySelectorAll('main variant-picker [data-vv-case-type], main variant-picker select[name="options[Kılıf Tipi]"], main [data-vv-fixed-type]')
    ];
    if (original.some(inView)) return;
    const container = document.querySelector('main .product-details product-form-component') ||
      document.querySelector('main product-form-component');
    if (!container?.parentElement) return;
    const fieldset = document.createElement('fieldset');
    fieldset.dataset.vvFallbackFieldset = 'true';
    fieldset.className = 'vv-type-rescue';
    const legend = document.createElement('legend');
    legend.textContent = 'Kılıf Tipi';
    fieldset.append(legend);
    const currentId = new URL(location.href).searchParams.get('variant');
    const selected = new URL(location.href).searchParams.get('vv_type');
    for (const choice of choices) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = choice.name;
      button.disabled = !choice.available;
      button.setAttribute('aria-pressed', String((currentId && String(choice.id) === currentId) || selected === choice.name));
      button.addEventListener('click', () => {
        const url = new URL(location.href);
        url.searchParams.set('variant', choice.id);
        url.searchParams.set('vv_type', choice.name);
        location.assign(url.href);
      });
      fieldset.append(button);
    }
    container.parentElement.insertBefore(fieldset, container);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();